<template>
  <div class="footer">
    <div class="footer-container container" v-if="lang === 'zh'">
      <p>最後修訂日期：19/10/2022</p>
      <p class="footer-link">
        <el-link @click="onRouteClick('Privacy')">隱私聲明</el-link>
        <span> | </span>
        <el-link @click="onRouteClick('Clause')">使用條款</el-link>
      </p>
      <p>Copyright© 2022 澳門科學技術發展基金 ALL rights reserved.</p>
    </div>
    <div class="footer-container container" v-if="lang === 'pt'">
      <p>Data da última revisão：19/10/2022</p>
      <p class="footer-link">
        <el-link @click="onRouteClick('Privacy')">Privacidade</el-link>
        <span> | </span>
        <el-link @click="onRouteClick('Clause')">Cláusula</el-link>
      </p>
      <p>
        Copyright© 2022 Fundo para o Desenvolvimento das Ciências e da
        Tecnologia de Macau ALL rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      lang: null,
    };
  },
  methods: {
    onRouteClick(name) {
      if (this.$route.name === name) return false;
      this.$router.push({ name: name });
    },
  },
  // 監聽下語言
  watch: {
    "$i18n.locale"(v) {
      this.lang = v;
    },
  },
  created() {
    this.lang = this.$i18n.locale;
  },
};
</script>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid #2742bb;
  background: #4b5fb8;
  padding: 30px 0;
  text-align: center;
  color: #fff;
}
.footer-link {
  text-decoration: none;
  ::v-deep .el-link {
    font-size: 16px;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
}
</style>
